export const MEDIA_TYPES = [
  { name: 'Planning', description: 'Planning activities' },
  { name: 'Images', description: 'Graphic images' },
  { name: 'Videos', description: 'Learning videos with the Video team' },
  { name: 'Animations', description: 'Motion and animations' },
  { name: 'Interactives', description: 'Interactive learning activities and elements' },
  { name: 'Build', description: 'Course build processes' },
]

export const MEDIA_ITEMS = [
  // Planning
  {
    name: 'Media planning workshop',
    type: 'Planning',
    hoursPer: 4,
    slug: 'pws',
    team: 'LRD',
    description: 'A planned session with 1-2 LRDs to work through course media ideas and budget allocation.',
  },
  {
    name: 'Course prototyping',
    type: 'Planning',
    hoursPer: 8,
    slug: 'ppt',
    team: 'LRD',
    description: 'Ideation and prototype creation for bespoke media objects where unique development; processes or testing is required.',
  },

  // Images
  {
    name: 'Re-used graphic',
    type: 'Images',
    hoursPer: 0.25,
    slug: 'gru',
    team: 'LRD',
    description: 'Basic treatment of an existing graphic e.g.: from a textbook.',
  },
  {
    name: 'Re-created graphic',
    type: 'Images',
    hoursPer: 0.75,
    slug: 'grc',
    team: 'LRD',
    description: 'Re-created graphics: Re-creation or bespoke creation of a simple graphic asset or a graphic to be used in a video.',
  },
  {
    name: 'Bespoke graphic',
    type: 'Images',
    hoursPer: 4,
    slug: 'gbs',
    team: 'LRD',
    description: 'Complex infographic style asset which displays complicated information and/or information flow. * Will need further discussion with Media Team.',
  },

  // Videos
  {
    name: 'Learning video',
    type: 'Videos',
    hoursPer: 3,
    slug: 'vln',
    team: 'VID',
    description: 'A video filmed in a UoA studio and edited by the Media Production team. Either with green screen or other background with graphic overlays and text on screen.',
  },
  {
    name: 'Interview video',
    type: 'Videos',
    hoursPer: 2,
    slug: 'viv',
    team: 'VID',
    description: 'An interview video filmed in a UoA studio and edited by the Media Production team.',
  },
  {
    name: 'Location video',
    type: 'Videos',
    hoursPer: 4,
    slug: 'vlc',
    team: 'VID',
    description: 'A video filmed on location (CBD or UoA campus only) with post-production by the Media Production team. *Will require further discussion.',
  },
  {
    name: 'Post-production',
    type: 'Videos',
    hoursPer: 1,
    slug: 'vpp',
    team: 'VID',
    description: 'A video filmed in a UoA studio without Media support; an audio-only podcast requiring edits; a Zoom interview; a lecture recording requiring post-production.',
  },

  // Animations
  {
    name: 'Short animation',
    type: 'Animations',
    hoursPer: 3,
    slug: 'ans',
    team: 'LRD',
    description: 'A 30-second or less simple animation timed to narrated voice-over; or simple .gif.',
  },
  {
    name: 'Medium animation',
    type: 'Animations',
    hoursPer: 6,
    slug: 'anm',
    team: 'LRD',
    description: 'A moderately complex animation and/or 45-90 seconds long timed to voice-over.',
  },
  {
    name: 'Long animation',
    type: 'Animations',
    hoursPer: 12,
    slug: 'anl',
    team: 'LRD',
    description: 'A complex and long (120+ second) animation with voice-over.',
  },

  // Interactives
  {
    name: 'Bespoke interactive',
    type: 'Interactives',
    hoursPer: 8,
    slug: 'ibs',
    team: 'LRD',
    description: 'A complex custom interactive solution. *Will require further discussion with the Media Team.',
  },
  {
    name: 'Repurpose bespoke interactive',
    type: 'Interactives',
    hoursPer: 4,
    slug: 'irb',
    team: 'LRD',
    description: 'Re-using or modifying a previous bespoke interactive with small functionality changes or tweaks.',
  },

  // Build
  {
    name: 'Course build',
    type: 'Build',
    hoursPer: 4,
    slug: 'bcb',
    team: 'DED',
    description: 'Set amount for each week of content built into platform. +1 to account for Orientation build.',
  },
  {
    name: 'Review Changes',
    type: 'Build',
    hoursPer: 0.25,
    slug: 'bch',
    team: 'DED',
    description: 'Set amount for post student/academic/LD review of each week of content.',
  },
  {
    name: 'Quizzes and Assessments',
    type: 'Build',
    hoursPer: 0.5,
    slug: 'bqa',
    team: 'DED',
    description: 'Building a quiz or assessment in MyUni.',
  },
  {
    name: 'H5P interactive',
    type: 'Build',
    hoursPer: 1,
    slug: 'bhp',
    team: 'DED',
    description: 'H5P interactive element.',
  },
  {
    name: 'Course rollover',
    type: 'Build',
    hoursPer: 4,
    slug: 'bcr',
    team: 'DED',
    description: 'Optional - preparing the course for a new teaching period.',
  },
]